/* tslint:disable:no-empty */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function noop() { }
//# sourceMappingURL=noop.js.map



//////////////////
// WEBPACK FOOTER
// /ng-app/node_modules/rxjs/_esm5/util/noop.js
// module id = ../../../../rxjs/_esm5/util/noop.js
// module chunks = vendor